import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SepaDataService {
  private paymentAmount = 0;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  setPaymentAmount(paymentAmount: number) {
    sessionStorage.setItem('paymentAmount', paymentAmount.toString());
    this.paymentAmount = paymentAmount;
  }

  getPaymentAmount() {
    if (this.paymentAmount === 0) {
      const stringAmount = sessionStorage.getItem('paymentAmount');
      if (stringAmount !== null && !isNaN(+stringAmount)) {
        this.paymentAmount = +stringAmount;
      }
    }
    return this.paymentAmount;
  }
}
